import React, { forwardRef } from "react";

import { cn } from "src/shadcn/lib/utils";
import {
  Kbd as PrimitiveKbd,
  KbdGroup as PrimitiveKbdGroup,
} from "src/primitives/Kbd";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "src/primitives/Tooltip";

import { SIDE_MAP } from "./constants";

export interface KbdProps extends React.ComponentProps<typeof PrimitiveKbd> {
  /** Optional tooltip to display on hover. */
  tooltipProps?: {
    content?: React.ReactNode;
    position?: string;
  };
  /** Additional CSS class names. */
  className?: string;
}

const Kbd = forwardRef<HTMLElement, KbdProps>(
  ({ tooltipProps, className, ...otherProps }, ref) => {
    if (!tooltipProps?.content) {
      return (
        <PrimitiveKbd ref={ref} className={cn(className)} {...otherProps} />
      );
    }

    const side = SIDE_MAP[tooltipProps.position ?? "auto"] ?? "top";

    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <PrimitiveKbd
              ref={ref}
              tabIndex={0}
              className={cn("pointer-events-auto", className)}
              {...otherProps}
            />
          </TooltipTrigger>
          <TooltipContent side={side}>{tooltipProps.content}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
);

Kbd.displayName = "Kbd";

const KbdGroup = PrimitiveKbdGroup;

const KbdNamespace = Object.assign(Kbd, { Group: KbdGroup });

export { KbdNamespace as Kbd };
